import LanguageRounded from "@mui/icons-material/LanguageRounded"
import { ListItemText, Menu, MenuItem } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { useRouter } from "next/router"
import type { FC } from "react"
import { useState } from "react"

const LOCALES = [
  { value: "en", label: "English" },
  { value: "ja", label: "日本語" },
] as const

/**
 * 言語切替 (#626)。地球アイコン → メニューで English / 日本語 を選択。
 *
 * 仕組み: 同じパスをロケール付きで開き直すだけ(/ja の付け外し)。
 * 選択は NEXT_LOCALE クッキーに保存し、次回のトップページ訪問時の
 * 自動判定より優先されるようにする。
 */
export const LanguageSwitcher: FC = () => {
  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const currentLocale = router.locale ?? "en"

  const onSelect = (locale: string) => {
    setAnchorEl(null)
    if (locale === currentLocale) return
    document.cookie = `NEXT_LOCALE=${locale}; path=/; max-age=31536000; SameSite=Lax`
    void router.push(router.asPath, undefined, { locale })
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label="language"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <LanguageRounded fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={() => setAnchorEl(null)}
      >
        {LOCALES.map((locale) => (
          <MenuItem
            key={locale.value}
            selected={locale.value === currentLocale}
            onClick={() => onSelect(locale.value)}
          >
            <ListItemText>{locale.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
